import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {Drivers} from '@ionic/storage';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {AngularFireRemoteConfigModule} from "@angular/fire/compat/remote-config";
import {AngularFireModule} from "@angular/fire/compat";
import {environment} from "~/environments/environment";
import {ComponentsModule} from "~/app/components/components.module";
import {CoreModule} from "~/app/core/core.module";
import {IonicStorageModule} from "@ionic/storage-angular";
import {HttpClientModule} from "@angular/common/http";
import {PagesModule} from "~/app/pages.module";
import {MarkdownModule} from "ngx-markdown";
import {HomeComponent} from "~/app/components/home/home.component";


@NgModule({
    declarations: [AppComponent],
    imports: [
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireRemoteConfigModule,
        IonicStorageModule.forRoot({name: "senya", driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage]}),
        HttpClientModule,
        BrowserModule,
        MarkdownModule.forRoot(),
        CoreModule.forRoot(),
        IonicModule.forRoot(),
        PagesModule,
        AppRoutingModule,
        ComponentsModule,
    ],
    providers: [{provide: RouteReuseStrategy, useClass: IonicRouteStrategy}, HomeComponent],
    bootstrap: [AppComponent],
})
export class AppModule {
}
